"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = require("styled-components");
var utils_1 = require("./utils");
exports.ThemeProvider = function (_a) {
    var themeType = _a.theme, children = _a.children;
    var theme = utils_1.getThemeByType(themeType);
    return react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme }, children);
};
